// Kredi kartı Harcama Ekle penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'finance.creditCardExpense';

export const creditCardExpenseGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'Kart harcaması nasıl eklenir?'),
  intro: t(`${G}.intro`, 'Şirket kredi kartıyla yaptığınız bir harcamayı kaydeder. Harcama kartın borcunu (kullanılan limiti) artırır. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık'),
    body: t(`${G}.regions.body`, 'Harcama formu'),
    footer: t(`${G}.regions.footer`, 'Kaydet'),
  },
  steps: [
    {
      region: 'body',
      title: t(`${G}.s1.title`, '1. Kartı ve kalan limiti kontrol edin'),
      text: t(`${G}.s1.text`, 'Üstteki kutuda kartın adı, numarası ve Kalan Limit görünür. Kalan limitten büyük bir harcama kaydedilemez.'),
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Tutar, tarih ve belge no'),
      text: t(`${G}.s2.text`, 'Tutarı sıfırdan büyük girin. İşlem Tarihi varsayılan olarak bugündür. Belge No (fiş / fatura no) isteğe bağlıdır.'),
      tips: [
        t(`${G}.s2.tip1`, 'Tutarı binlik ayracı olmadan yazın; kuruş için virgül kullanın (ör. 1500,50).'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Gider türü ve proje'),
      text: t(`${G}.s3.text`, 'Gider türü, harcamanın Kâr-Zarar raporunda hangi başlıkta görüneceğini belirler; boş bırakılırsa "Kategorisiz" görünür. Proje seçerseniz harcama o projenin maliyetine yazılır.'),
      tips: [
        t(`${G}.s3.tip1`, 'Şube yöneticisi olarak girdiyseniz gider türü zorunludur ve proje alanı görünmez.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s4.title`, '4. Kaydedin'),
      text: t(`${G}.s4.text`, 'Açıklama boş bırakılırsa "Kart harcaması" yazılır. "Kaydet" sonrası kartın borcu harcama tutarı kadar artar; hareket Kart Hareketleri listesinde "Harcama" olarak görünür. Başlıktaki (i) bu rehberi yeniden açar.'),
    },
  ],
});
